import { ArrowRight } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';

const ClubsCTA = () => {
    return (
        <div className='home-clubs-cta'>
            <h5>Find Venues</h5>
            <p>Discover clubs, ranges, and shoots near you or view your favourites.</p>
            <Link to="/dashboard/clubs">
                Browse Venues
                <ArrowRight size={18} />
            </Link>
        </div>
    );
};

export default ClubsCTA;
